// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmViewCrudState {
constructor({
        id = null,
        code = '',
        name = '',
        icon = '',
        menuNameI18n = '',
        breadcrumbNameI18n = '',
        menuTypeCode = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.icon = icon;
    this.menuNameI18n = menuNameI18n;
    this.breadcrumbNameI18n = breadcrumbNameI18n;
    this.menuTypeCode = menuTypeCode;
    this.description = description;
}
}

function newEntity() {
return new EmViewCrudState();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.em.admin.emViewCrudState.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emViewCrudState.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'icon',
        label: 'label.em.admin.emViewCrudState.grid.icon',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'menuNameI18n',
        label: 'label.em.admin.emViewCrudState.grid.menuNameI18n',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'breadcrumbNameI18n',
        label: 'label.em.admin.emViewCrudState.grid.breadcrumbNameI18n',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'menuTypeCode',
        label: 'label.em.admin.emViewCrudState.grid.menuTypeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.admin.emViewCrudState.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    codeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emViewCrudState.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.emViewCrudState.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.admin.emViewCrudState.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emViewCrudState.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'icon',
        label: 'label.em.admin.emViewCrudState.entity.icon',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emCssIcon'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'menuNameI18n',
        label: 'label.em.admin.emViewCrudState.entity.menuNameI18n',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'breadcrumbNameI18n',
        label: 'label.em.admin.emViewCrudState.entity.breadcrumbNameI18n',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'menuTypeCode',
        label: 'label.em.admin.emViewCrudState.entity.menuTypeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emMenuType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'description',
        label: 'label.em.admin.emViewCrudState.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmViewCrudState, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
